import { Controller } from "@hotwired/stimulus"

// MED-41 — the progress of an upload, one bar per file.
//
// Active Storage does the work: with `direct_upload: true` the file goes
// straight to storage and the form carries only the signed id afterwards. What
// it does not bring is anything to look at, and that is the whole point of the
// requirement — a hundred megabytes of video over a mobile connection is
// minutes of a form that otherwise sits there looking broken.
//
// The events fire on the file input and bubble, so one controller around a form
// covers however many inputs it has.
export default class extends Controller {
  static targets = ["list"]

  connect() {
    this.bars = new Map()
  }

  // direct-upload:initialize — one bar per file, named, so somebody uploading
  // twelve pictures can tell which one is still going.
  start(event) {
    const { id, file } = event.detail
    const row = document.createElement("div")
    row.className = "mb-2"
    row.innerHTML = `
      <div class="d-flex justify-content-between small">
        <span class="text-truncate me-2"></span>
        <span class="text-body-secondary flex-shrink-0">0 %</span>
      </div>
      <div class="progress" style="height: .5rem">
        <div class="progress-bar" role="progressbar" style="width: 0%"
             aria-valuemin="0" aria-valuemax="100" aria-valuenow="0"></div>
      </div>`
    // textContent rather than markup: a file name is somebody else's input.
    row.querySelector("span").textContent = file.name

    this.listTarget.appendChild(row)
    this.listTarget.classList.remove("d-none")
    this.bars.set(id, row)
  }

  progress(event) {
    const { id, progress } = event.detail
    const row = this.bars.get(id)
    if (!row) return

    const percent = Math.round(progress)
    const bar = row.querySelector(".progress-bar")
    bar.style.width = `${percent}%`
    bar.setAttribute("aria-valuenow", percent)
    row.querySelectorAll("span")[1].textContent = `${percent} %`
  }

  // The upload is through; what follows is the form submit and then the reading
  // of the file, which reports itself (MED-42).
  finish(event) {
    const row = this.bars.get(event.detail.id)
    if (!row) return

    row.querySelector(".progress-bar").classList.add("bg-success")
  }

  error(event) {
    const row = this.bars.get(event.detail.id)
    if (!row) return

    row.querySelector(".progress-bar").classList.add("bg-danger")
    row.querySelectorAll("span")[1].textContent = event.detail.error
    // Otherwise Active Storage logs it to the console and nothing else.
    event.preventDefault()
  }
}
